import React, { FC } from 'react';
import { TItemListProps } from '../../../../../types/dealerLocator.types';
import HiglightedOption from '../../../../../../@shared/highlightedOption';

export const ItemList: FC<TItemListProps> = (props: TItemListProps) => {
    return (
        <ul className="preferred-dealer-search__text-search-suggestion-group">
            {props?.items?.map((item, i) => (
                <li
                    className={`preferred-dealer-search__list-item ${props?.highlightedSuggestionIndex === i ? 'preferred-dealer-search__list-item--highligted' : ''
                        }`}
                    onMouseEnter={() => props.mouseEnterHandler(i)}
                    onClick={() => props.clickHandler(item)} // eslint-disable-line
                    key={props.keyGenerator(item)}
                >
                    <HiglightedOption keyword={props.searchText} optionText={props.optionTextHandler(item)} />
                </li>
            ))}
        </ul>
    );
};

export default ItemList;


